import React, { Component} from 'react';
import {NavLink} from 'react-router-dom'
import Privacy from '../container/Pages/Policies/PrivacyPolicy'
import API from'../utilities/API'

//import {BrowserRouter as Router,  NavLink, Redirect  } from 'react-router-dom'

class Register extends Component {
 
constructor (props) {
    super(props);

    this.inviteReturn = this.inviteReturn.bind(this);
    this.state = {display:0,
                  e:'',
                  p:'',
                  c:'',
                  errE: null,
                  errP: null,
                  errC: null,
    }
     
}

handleOnChange = event => {
  event.preventDefault();
  const { name, value } = event.target;
  
  this.setState({
    [name]: value
  });
  
}

handleSubmit = event => {
  event.preventDefault();
    
    let e = this.state.e;
    let p = this.state.p;
    let c = this.state.c;
    const Reg = {
      email: e,
      password: p,
      c: c
      
    }
    
  if(this.validate()){
    
    API.sendUserInvite(Reg, this.inviteReturn);
  }  
}
inviteReturn(outcome){
  let NextDisplay = 0;
  if (outcome){
  switch(outcome.route){
    case '/register/founduser':
      NextDisplay = 3;
      break;
    case '/register/success':
      NextDisplay = 1;
      break;
    default:
       NextDisplay = 2;
      break;
  }}
 
  this.setState({e:'',p:'',c:'', display:NextDisplay});
}

validate(){
  
  let isValid = true;
  let errorE = null;
  let errorP = null;
  let errorC = null;
  if(this.state.p!==this.state.c){
    errorP="Passwords don't match.";
    errorC="Passwords don't match.";
    isValid = false;
  }
  if(this.state.p.length<=0){
    errorP = "Password can not be blank.";
    isValid = false;
  }
  if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.e))){
    errorE="Invalid email format";
    isValid = false; 
  }
  if(this.state.e.length<=0){
    errorE= "Email can not be blank.";
    isValid = false;
  }

  if(this.state.c.length<=0){
    errorC="Password confirmation can not be blank.";
    isValid = false;
  }
  

  this.setState({errE: errorE,
                 errP:errorP,
                 errC: errorC})
  
  return isValid;
}

render() { 
  let regPage = ()=>(<div></div>);
  switch(this.state.display){
    case 0:
    regPage = ()=> (<div className='mypage fluid-container p-3'>
    <div className='row'>
    
    <div className='col-3' Style="min-width: 200px">
    <h2>Register</h2>
    
    <div className='row'>
    <div className='myfldlbl col-12 mx-2'>Email</div>
    <div className='col-12 mx-2'><input className="form-control" type='text' name='e' value={this.state.e} onChange={this.handleOnChange}/></div>
    <div className='myerr col-12 mx-2'>{this.state.errE}</div>
    </div>
  
    <div className='row'>
    <div className='myfldlbl col-12 mx-2'>Password</div>
    <div className='col-12 mx-2'><input className="form-control" type='password' name='p' value={this.state.p} onChange={this.handleOnChange}/></div>
    <div className='myerr col-12 mx-2'>{this.state.errP}</div>
    </div>
  
    <div className='row'>
    <div className='myfldlbl col-12 mx-2'>Confirm Password</div>
   <div className='col-12 mx-2'><input className="form-control" type='password' name='c' onChange={this.handleOnChange} value={this.state.c}/></div>
    <div className='myerr col-12 mx-2'>{this.state.errC}</div>
    </div>
  
    <div className='row'>
    <div className='col-12 mx-2'>
    <div className="btn btn-dark mt-2" onClick={this.handleSubmit}>Register</div>
    </div>
    </div>
    
    </div>
    <div className='col-9'>
    {<Privacy/>}
    </div>
    </div>  
    
    </div>
    );
    break;
     case 1:
     regPage = ()=> (<div className='fluid-container p-3'>
    <h4>Congratulations</h4>
    <p>You have registered successfully! You should receive an email within the next few minutes.</p> 
    <p>Simply click on the link in the email and acccept the terms of our site.</p>
    <p>This will give you access to the sites games and forums to start having fun! </p>
   
      
    </div>)
      break;
    case 3:  
    default:
    
      regPage = ()=> (<div className='fluid-container p-3'>
     
     <h4>This email is already a valid user on our site...</h4>
     <p>Try logging in with that email by following the link below.</p>
     <NavLink to="/login">Login Now</NavLink>
       
     </div>);
       break;
    
     
  }
  
  return (regPage());            
          

  
}
}

export default Register;
// import React from 'react';

// const Register = (props)=>(
//   <div className='fluid-container p-3'>
//   <h4>Register</h4>
  
//   <div className='row'>
//   <div className='col-6 mx-2'>Email</div>
//   <div className='col-6 mx-2'><input type='text'/></div>
//   </div>

//   <div className='row'>
//   <div className='col-6 mx-2'>Password</div>
//   <div className='col-6 mx-2'><input type='password'/></div>
//   </div>

//   <div className='row'>
//   <div className='col-6 mx-2'>Confirm Password</div>
//   <div className='col-6 mx-2'><input type='password'/></div>
//   </div>

//   <div className='row'>
//   <div className='col-6 mx-2'>
//   <div className="btn btn-dark mt-2">Register</div>
//   </div>
  
//   </div>
//   </div>);

// export default Register; 


// WEBPACK FOOTER //
// ./src/components/Register.js